import Couchdb from 'src/services/Couchdb'

const dashboardCounter = (model, eventsId, dateRange) => {
  const query = {
    connection: 'default',
    ddoc: 'dashboard-counter-model-event-date',
    view: 'dashboard-counter-model-event-date',
    queries: []
  }
  if (eventsId) {
    eventsId.forEach(element => {
      const queryBuilder = {
        reduce: true,
        group_level: 1,
        inclusive_end: true,
        start_key: defineKeys(model, element, dateRange).start_key,
        end_key: defineKeys(model, element, dateRange).end_key
      }
      query.queries.push(queryBuilder)
    })
  }
  return reduceResult(query)
}

const dashboardCustomersCounter = (dateRange) => {
  const query = {
    connection: 'default',
    ddoc: 'count-customers-all',
    view: 'count-customers-all',
    queries: [
      {
        start_key: dateRange[0],
        end_key: dateRange[1]
      }
    ]
  }
  return reduceResult(query)
}

const dashboardSurveysCounter = (eventsId, dateRange) => {
  const query = {
    connection: 'surveys',
    ddoc: 'counters',
    view: 'surveys-by-status',
    queries: [{
      reduce: true
    }]
  }
  // if (eventsId) {
  //   eventsId.forEach(element => {
  //     const queryBuilder = {
  //       reduce: true,
  //       group_level: 1,
  //       inclusive_end: true,
  //       start_key: defineKeys('FINISHED', element, dateRange).start_key,
  //       end_key: defineKeys('FINISHED', element, dateRange).end_key
  //     }
  //     console.log(queryBuilder)
  //     query.queries.push(queryBuilder)
  //   })
  // }
  return reduceResult(query)
}

const defineKeys = (model, eventsId, dateRange) => {
  if (dateRange && dateRange.length !== 0) {
    const query = {
      start_key: [model, eventsId],
      end_key: [model, eventsId]
    }
    if (dateRange[0] && !dateRange[1]) {
      query.start_key.push(dateRange[0])
      query.end_key.push({})
      return query
    }
    if (!dateRange[0] && dateRange[1]) {
      query.end_key.push(dateRange[1])
      return query
    }
    query.start_key.push(dateRange[0])
    query.end_key.push(dateRange[1])
    return query
  }
  if (eventsId) {
    const query = {
      start_key: [model, eventsId],
      end_key: [model, eventsId, {}]
    }
    return query
  }
  return {
    start_key: [model],
    end_key: [model, {}]
  }
}

const reduceResult = (query) => {
  return Couchdb.viewQueries(query)
    .then(result => {
      return result.reduce((acc, curr) => {
        if (curr.rows.length > 0) {
          return Number(acc) + Number(curr.rows[0].value)
        }
        return acc
      }, 0)
    })
}

const verifyEmptyTags = function (tags) {
  let emptyTags = true
  for (let categorie in tags) {
    emptyTags = emptyTags && tags[categorie].length === 0
  }
  return emptyTags
}

const defineWhereObject = function (dateRange, tags, fieldTags) {
  let labelTag = !fieldTags ? 'tags' : fieldTags
  const where = {'$and': []}
  if (dateRange && dateRange.length > 0) {
    where['$and'].push({
      'startDate': {
        '$gte': dateRange[0]
      }
    })
    where['$and'].push(
      {
        'startDate': {
          '$lte': dateRange[1]
        }
      })
  }

  if (verifyEmptyTags(tags)) {
    return where
  }
  for (let categorie in tags) {
    if (tags[categorie].length === 0) continue

    const orWhere = []
    for (let tag of tags[categorie]) {
      let fieldWhere = {}
      fieldWhere[labelTag] = {
        '$elemMatch': {
          '$eq': tag
        }
      }
      orWhere.push(fieldWhere)
    }

    if (orWhere.length === 0) {
      continue
    }

    where['$and'].push({
      '$or': orWhere
    })
  }
  return where
}

export {
  dashboardCounter,
  dashboardCustomersCounter,
  dashboardSurveysCounter,
  verifyEmptyTags,
  defineWhereObject
}



// WEBPACK FOOTER //
// ./src/services/DashboardCounter.js